module.exports = __webpack_public_path__ + "img/john_jenkins.89e690ce.png";